import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsTargetPlus() {
  return (
    <IntegrationDocTemplate
      title="Target Plus"
      category="Marketplace · Invite-only"
      status="in_progress"
      summary="Target Plus is an invite-only marketplace with mandatory EDI compliance. Documents: 850, 855, 856, 810, 997. Perfect Order Program requires 100% error-free ASNs. Chargebacks: 5% COGS minimum for OTFR violations, 3% COGS for ASN errors."
      prerequisites={[
        'Target Plus invite (you must apply and be approved).',
        'EDI capability — we provide this via our X12 + AS2 module.',
        'Compliance with Target vendor requirements: ship in 24h, deliver in 5 days, price parity.',
        'US business presence + product/content compliance.',
      ]}
      connectSteps={[
        'Send us your Target Plus seller credentials via Talk to Sales (these are partnership-managed).',
        'We configure AS2 trading-partner setup with Target.',
        '1-week parallel run on Target test environment to certify Perfect Order Program compliance.',
        'Production cut-over once 0 chargebacks for 7 days.',
      ]}
      syncedData={[
        { type: '850 (PO)', detail: 'Inbound, parsed into purchase orders' },
        { type: '855 (PO Ack)', detail: 'Outbound within 24h — auto-acknowledge with confirmed quantities + ship date' },
        { type: '856 (ASN)', detail: 'Outbound — Perfect Order Program requires 100% error-free; SSCC labels mandatory' },
        { type: '810 (Invoice)', detail: 'Outbound — must match 856 line-by-line' },
        { type: '997 (Functional Ack)', detail: 'Bidirectional confirmation' },
      ]}
      agents={[
        { id: 'target_compliance_agent', name: 'target_compliance_agent', role: 'Perfect Order Program compliance monitoring + ASN accuracy' },
        { id: 'asn_agent', name: 'asn_agent', role: '856 generation with SSCC + barcode validation' },
        { id: 'invoice_match_agent', name: 'invoice_match_agent', role: '810 generation' },
      ]}
      troubleshooting={[
        { question: 'ASN accuracy below 100%', answer: 'Even 1% error rate triggers chargebacks. Pre-flight validator should catch issues; check sync_log for which segment failed.' },
        { question: 'OTFR (On-Time Fill Rate) violation', answer: '5% COGS min $150 chargeback per shipment. Set up auto-allocation in our /3pl marketplace to ensure ship cutoffs are met.' },
        { question: 'Physical Barcode Accuracy fail', answer: 'Walmart-grade barcode scanning required. Use only the SSCC labels we generate (GS1-128 with mod-10 check digit).' },
      ]}
      supportLink="/contact"
    />
  );
}
